import React from 'react';

import { Col } from 'antd';

import { fieldIsBlock, FieldsActionBR, FieldsNameBR } from '../../constants';
import type { ChangeLogHistoryItemValue } from '../../constants';
import formatHistoryInfo from '../formatters';

type HistoryDetailsItems = {
  field: string;
  change: ChangeLogHistoryItemValue;
};

function HistoryDetailsItems({ field, change }: HistoryDetailsItems) {
  const fieldHasBooleanValue = typeof field === 'boolean';
  const haveOnlyTo = change.action === 'add';
  const showFrom = !fieldHasBooleanValue || !haveOnlyTo;
  const showTo = !fieldHasBooleanValue;

  return (
    <Col span={24}>
      <div className='flex flex-col [&_p]:p-1 [&:not(:last-child)]:pb-6'>
        <div className='grow'>
          <p className='text-base'>{FieldsNameBR[field as keyof typeof FieldsNameBR]}</p>
        </div>
        <div
          className='flex data-[block=true]:flex-col max-sm:flex-col [&>div]:flex [&>div]:items-center'
          data-block={fieldIsBlock.includes(field)}
          key={field}
        >
          <div>
            <p className='inline-block bg-[#FFFCE6] text-base'>{FieldsActionBR[change.action]}</p>
          </div>
          {change?.status && (
            <div>
              <p className='text-base'>{change.status}</p>
            </div>
          )}
          {showFrom && (
            <div>
              <p className='text-base text-[#00000073] line-through [line-break:anywhere] [&_img]:opacity-50'>
                {formatHistoryInfo(field, change.from)}
              </p>
            </div>
          )}
          {showTo && (
            <div>
              <p className='text-base [line-break:anywhere]'>{formatHistoryInfo(field, change.to)}</p>
            </div>
          )}
        </div>
      </div>
    </Col>
  );
}

export default HistoryDetailsItems;
